import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          {/* <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit duis sed
            dapibus leonec.
          </p> */}
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
         <div className="col-md-4 d-flex">
  <div className="card text-center p-4 shadow-sm w-100">
    <i className={d.icon}></i>
    <h3 className="mt-3">{d.name}</h3>
    <p>{d.text}</p>
  </div>
</div>


              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
